<h2 mat-dialog-title>Bulk remove keyframes</h2>

<mat-dialog-content>
  <form>
    <div class="frame-range-container">
      <div class="start-frame">
        <label>
          Start frame
          <h3-number-input
            [min]="0"
            [max]="endFrameControl.value"
            [step]="1"
            [formControl]="startFrameControl"
          ></h3-number-input>
        </label>
      </div>
      <div>
        <label>
          End frame
          <h3-number-input
            [min]="startFrameControl.value"
            [max]="lastFrameNumber"
            [step]="1"
            [formControl]="endFrameControl"
          ></h3-number-input
        ></label>
      </div>
    </div>
    <div class="checkbox-container">
      <div class="checkbox-option">
        <h3-checkbox [formControl]="includeKeyframesFormControl"
          >Keyframes
          <fa-icon
            [icon]="faWindowMinimize"
            [fixedWidth]="true"
            [rotate]="90"
            transform="right-7 up-1"
          ></fa-icon
        ></h3-checkbox>
        <h3-help-tooltip
          text="All keyframes within the start and end range will be removed"
        ></h3-help-tooltip>
      </div>

      <div *ngIf="includeKeyframesFormControl.value" class="remove-mode">
        <span>Keyframes to keep </span>
        <h3-help-tooltip
          text="The first or last keyframe will be preserved if there are no keyframes within a shape upon bulk remove"
        ></h3-help-tooltip>
        <span> :</span>
        <div class="radio">
          <label>
            <input
              type="radio"
              [formControl]="keyframeToPreserveOnDeletionFormControl"
              value="first"
            />
            First
          </label>

          <label>
            <input
              type="radio"
              [formControl]="keyframeToPreserveOnDeletionFormControl"
              value="last"
            />
            Last
          </label>
        </div>
      </div>

      <div class="checkbox-option">
        <h3-checkbox [formControl]="includeDynamicTagsFormControl"
          >Dynamic attributes
          <div class="dynamic-attribute-indicator"></div
        ></h3-checkbox>
        <h3-help-tooltip
          text="All dynamic labels will be removed within the start and end range"
        ></h3-help-tooltip>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <h3-button
    type="danger"
    (h3Click)="close()"
    [disable]="disableTooltipText$ | async"
  >
    Remove all keyframes
  </h3-button>
  <h3-button (h3Click)="cancel()"> Cancel </h3-button>
</mat-dialog-actions>
